var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNote = function SvgNote(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C5 3.44772 5.44772 3 6 3H18C18.5523 3 19 3.44772 19 4V9.91597L14 14.9167V17H16.083L19 14.0826V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V4ZM19 14.0826L22.2266 10.8556L20.1436 8.77222L19 9.91597V14.0826ZM7 7H17V6H7V7ZM17 10H7V9H17V10ZM21.7545 7.16111C21.86 7.05556 22.0044 7 22.1433 7C22.2877 7 22.4266 7.05 22.5377 7.16111L23.8375 8.46111C24.0542 8.67778 24.0542 9.02778 23.8375 9.24444L22.821 10.2611L20.738 8.17778L21.7545 7.16111Z",
    fill: "#8B90A0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNote);
export { ForwardRef as ReactComponent };